module.exports = __webpack_public_path__ + "img/TheMembers-4-en.d5ed2fff.png";